// src/enums.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["CUSTOMER"] = "customer";
  UserRole2["RESTAURANT_OWNER"] = "restaurant_owner";
  UserRole2["RIDER"] = "rider";
  UserRole2["SUPER_ADMIN"] = "super_admin";
  return UserRole2;
})(UserRole || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["PENDING"] = "pending";
  OrderStatus2["CONFIRMED"] = "confirmed";
  OrderStatus2["PREPARING"] = "preparing";
  OrderStatus2["READY"] = "ready";
  OrderStatus2["PICKED_UP"] = "picked_up";
  OrderStatus2["DELIVERED"] = "delivered";
  OrderStatus2["CANCELLED"] = "cancelled";
  return OrderStatus2;
})(OrderStatus || {});
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["PENDING"] = "pending";
  PaymentStatus2["COMPLETED"] = "completed";
  PaymentStatus2["FAILED"] = "failed";
  PaymentStatus2["REFUNDED"] = "refunded";
  return PaymentStatus2;
})(PaymentStatus || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["PAYSTACK"] = "paystack";
  PaymentMethod2["WALLET"] = "wallet";
  PaymentMethod2["CASH"] = "cash";
  return PaymentMethod2;
})(PaymentMethod || {});
var RestaurantApprovalStatus = /* @__PURE__ */ ((RestaurantApprovalStatus2) => {
  RestaurantApprovalStatus2["PENDING_REVIEW"] = "pending_review";
  RestaurantApprovalStatus2["INFO_REQUESTED"] = "info_requested";
  RestaurantApprovalStatus2["APPROVED"] = "approved";
  RestaurantApprovalStatus2["REJECTED"] = "rejected";
  RestaurantApprovalStatus2["SUSPENDED"] = "suspended";
  RestaurantApprovalStatus2["TERMINATED"] = "terminated";
  return RestaurantApprovalStatus2;
})(RestaurantApprovalStatus || {});
var VehicleType = /* @__PURE__ */ ((VehicleType2) => {
  VehicleType2["BICYCLE"] = "bicycle";
  VehicleType2["MOTORCYCLE"] = "motorcycle";
  VehicleType2["CAR"] = "car";
  return VehicleType2;
})(VehicleType || {});
var DeliveryFeeType = /* @__PURE__ */ ((DeliveryFeeType2) => {
  DeliveryFeeType2["FIXED"] = "fixed";
  DeliveryFeeType2["DISTANCE_BASED"] = "distance_based";
  return DeliveryFeeType2;
})(DeliveryFeeType || {});
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["ORDER_STATUS"] = "order_status";
  NotificationType2["NEW_ORDER"] = "new_order";
  NotificationType2["RIDER_JOB"] = "rider_job";
  NotificationType2["PROMO"] = "promo";
  NotificationType2["SYSTEM"] = "system";
  NotificationType2["RESTAURANT_APPLIED"] = "restaurant_applied";
  NotificationType2["RIDER_REGISTERED"] = "rider_registered";
  NotificationType2["REFUND_REQUESTED"] = "refund_requested";
  NotificationType2["ADMIN_ACTION"] = "admin_action";
  return NotificationType2;
})(NotificationType || {});
var Country = /* @__PURE__ */ ((Country2) => {
  Country2["NIGERIA"] = "NG";
  Country2["GHANA"] = "GH";
  Country2["KENYA"] = "KE";
  return Country2;
})(Country || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["NGN"] = "NGN";
  Currency2["GHS"] = "GHS";
  Currency2["KES"] = "KES";
  return Currency2;
})(Currency || {});
export {
  Country,
  Currency,
  DeliveryFeeType,
  NotificationType,
  OrderStatus,
  PaymentMethod,
  PaymentStatus,
  RestaurantApprovalStatus,
  UserRole,
  VehicleType
};
